import React, {createContext, PropsWithChildren, useContext, useState} from 'react';
import {noop} from 'lodash';
import {CustomFieldDefinition} from '@/forecast-app/admin-tab/custom-fields-page/types';

export type Column = {
	id: string;
	visible: boolean;
	toggleable: boolean;
} & {translationId?: string; displayName?: string} & {
	customFieldDefinition?: CustomFieldDefinition;
};

interface TimesheetTableContext {
	columnDefinitions: Column[];
	setColumnDefinitions: React.Dispatch<React.SetStateAction<Column[]>>;
}

const TimesheetTableContext = createContext<TimesheetTableContext>({
	columnDefinitions: [],
	setColumnDefinitions: noop,
});

export const useTimesheetTableContext = (): TimesheetTableContext => {
	return useContext(TimesheetTableContext);
};

export function TimesheetTableContextProvider({children}: PropsWithChildren<unknown>): JSX.Element {
	const [columnDefinitions, setColumnDefinitions] = useState<Column[]>([]);

	return (
		<TimesheetTableContext.Provider value={{columnDefinitions, setColumnDefinitions}}>
			{children}
		</TimesheetTableContext.Provider>
	);
}
